import script from "./LogEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./LogEntry.vue?vue&type=script&setup=true&lang=ts"

import "./LogEntry.vue?vue&type=style&index=0&id=a3c49014&lang=postcss&scoped=true"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3c49014"]])

export default __exports__